
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import Settings from "@/components/Singularity/Settings/Settings.vue";

@Component({
  components: {
    Settings
  }
})
export default class SingularityFullWidthPanel extends Vue {
  get singularityFullWidthPanel() {
    return singularityStore.singularityUiState.singularityFullWidthPanel;
  }
}
